module.exports = __webpack_public_path__ + "static/media/bonus_workout_pattern.05477bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bonus_workout_pattern.png
// module id = 163
// module chunks = 0